"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignatureEvents = void 0;
const react_1 = require("react");
const features_1 = require("../../features");
const hooks_1 = require("../../authoriser/hooks");
const useSignatureEvents = ({ onChangeState }) => {
    const notifications = (0, hooks_1.useAuthoriserNotifications)();
    const publishers = {
        validateSignatureEvent: data => {
            (0, features_1.publishValidateSignatureEvent)(data);
        },
        cancelSignatureEvent: () => {
            (0, features_1.publishCancelSignatureEvent)();
        },
        resetSignatureEvent: () => {
            (0, features_1.publishResetSignatureEvent)();
        },
    };
    const onStateChange = data => {
        onChangeState(data);
    };
    const doVerify = (data) => {
        publishers.validateSignatureEvent(data);
    };
    const doCancel = () => {
        publishers.cancelSignatureEvent();
    };
    const reset = () => {
        publishers.resetSignatureEvent();
    };
    (0, react_1.useEffect)(() => {
        const subscriptions = [
            (0, features_1.subscribeFinishSignatureEvent)(onStateChange),
            (0, features_1.subscribeShowSignatureEvent)(onStateChange),
            (0, features_1.subscribeErrorSignatureEvent)(onStateChange),
            (0, features_1.subscribeCancelSignatureEvent)(onStateChange),
        ];
        return () => {
            subscriptions.forEach(unsubscribe => unsubscribe());
        };
    }, []);
    return {
        doVerify,
        doCancel,
        reset,
        ...notifications,
    };
};
exports.useSignatureEvents = useSignatureEvents;
//# sourceMappingURL=useSignatureEvents.hook.js.map